import { forwardRef } from "react";

import { useTheme } from "@mui/material";

import {
  BaseFormPaymentMethod,
  BaseFormPaymentMethodProps,
} from "@/forms-design-system/FormPaymentMethod/BaseFormPaymentMethod";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { useTranslate } from "@/hooks/useTranslate";
import { StripeCheque } from "@/icons/external";

type CashFormPaymentMethodProps = Omit<BaseFormPaymentMethodProps, "icon" | "label"> & {
  label?: string;
};

export const CashFormPaymentMethod = forwardRef<HTMLDivElement, CashFormPaymentMethodProps>(
  ({ label, ...rest }, ref) => {
    const theme = useTheme();
    const { t } = useTranslate();

    if (!theme.palette.forms || !theme.palette.formsComponents?.paymentMethod) {
      return <InvalidThemeErrorMessage />;
    }

    return (
      <BaseFormPaymentMethod
        ref={ref}
        icon={<StripeCheque />}
        label={label ?? t("common", "paymentMethod.cash")}
        {...rest}
      />
    );
  }
);

CashFormPaymentMethod.displayName = "CashFormPaymentMethod";
